var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoctorOffice = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "0 0 80 80"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1F1FF",
  d: "M70.998 39.756a31.401 31.401 0 0 0-62.794-.65 31.4 31.4 0 0 0 2.792 13.602H68.2a31.3 31.3 0 0 0 2.798-12.952"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.983 52.71h61.23M5.45 52.71h1.963M71.783 52.71h1.963"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.598 52.699h-7.557v-20a.785.785 0 0 1 .785-.784h6.772z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M39.598 52.699h-7.557v-20a.785.785 0 0 1 .785-.784h6.772z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M74.55 40.891a1.413 1.413 0 0 1-1.418 1.413H61.324v-2.83h11.808a1.417 1.417 0 0 1 1.417 1.417"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M74.55 40.891a1.413 1.413 0 0 1-1.418 1.413H61.324v-2.83h11.808a1.417 1.417 0 0 1 1.417 1.417"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M67.465 52.699h2.361l1.89-10.391h-2.362z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M67.465 52.699h2.361l1.89-10.391h-2.362z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M61.325 52.699H39.598V18.533a.785.785 0 0 1 .785-.785H60.54a.785.785 0 0 1 .785.785z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M61.325 52.699H39.598V18.533a.785.785 0 0 1 .785-.785H60.54a.785.785 0 0 1 .785.785z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M61.485 30.5H39.439a.785.785 0 0 0-.785.786v.791a.785.785 0 0 0 .785.785h22.046a.785.785 0 0 0 .785-.785v-.79a.785.785 0 0 0-.785-.786"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M62.269 20.11H38.654v-1.577a.785.785 0 0 1 .785-.785h22.045a.785.785 0 0 1 .785.785z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M62.269 20.11H38.654v-1.577a.785.785 0 0 1 .785-.785h22.045a.785.785 0 0 1 .785.785z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M54.559 10.19h-8.196a1.57 1.57 0 0 0-1.57 1.57v8.196a1.57 1.57 0 0 0 1.57 1.57h8.196a1.57 1.57 0 0 0 1.57-1.57V11.76a1.57 1.57 0 0 0-1.57-1.57"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M54.559 10.19h-8.196a1.57 1.57 0 0 0-1.57 1.57v8.196a1.57 1.57 0 0 0 1.57 1.57h8.196a1.57 1.57 0 0 0 1.57-1.57V11.76a1.57 1.57 0 0 0-1.57-1.57"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M53.455 14.441h-1.576v-1.576a.785.785 0 0 0-.785-.785h-1.265a.785.785 0 0 0-.785.785v1.576h-1.576a.785.785 0 0 0-.785.785v1.265a.785.785 0 0 0 .785.785h1.576v1.576a.785.785 0 0 0 .785.785h1.264a.785.785 0 0 0 .785-.785v-1.576h1.577a.785.785 0 0 0 .785-.785v-1.264a.785.785 0 0 0-.785-.786"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M55.657 52.699H45.266v-9.606a.785.785 0 0 1 .785-.785h8.82a.785.785 0 0 1 .786.785z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M55.657 52.699H45.266v-9.606a.785.785 0 0 1 .785-.785h8.82a.785.785 0 0 1 .786.785zM50.462 42.308v10.39"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M45.425 23.888h-2.208a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.208a.785.785 0 0 0 .785-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M45.425 23.888h-2.208a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.208a.785.785 0 0 0 .785-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.566 23.888h-2.209a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.209a.785.785 0 0 0 .784-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M51.566 23.888h-2.209a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.209a.785.785 0 0 0 .784-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M57.706 23.888h-2.209a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.209a.785.785 0 0 0 .785-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M57.706 23.888h-2.209a.785.785 0 0 0-.785.785v2.68a.785.785 0 0 0 .785.786h2.209a.785.785 0 0 0 .785-.785v-2.681a.785.785 0 0 0-.785-.785"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M57.706 35.223h-2.209a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.209a.785.785 0 0 0 .785-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M57.706 35.223h-2.209a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.209a.785.785 0 0 0 .785-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.566 35.223h-2.209a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.209a.785.785 0 0 0 .784-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M51.566 35.223h-2.209a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.209a.785.785 0 0 0 .784-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M45.425 35.223h-2.208a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.208a.785.785 0 0 0 .785-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M45.425 35.223h-2.208a.785.785 0 0 0-.785.785v2.681a.785.785 0 0 0 .785.785h2.208a.785.785 0 0 0 .785-.785v-2.68a.785.785 0 0 0-.785-.786"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.956 27.968a11.884 11.884 0 0 0-11.883 11.884v4.441a10.5 10.5 0 0 0 4.296 8.385l-.863 7.742a1.1 1.1 0 0 0 1.09 1.218h14.717a1.1 1.1 0 0 0 1.09-1.218l-.863-7.742a10.5 10.5 0 0 0 4.297-8.384V39.85a11.883 11.883 0 0 0-11.88-11.883"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M25.956 27.968a11.884 11.884 0 0 0-11.883 11.884v4.441a10.5 10.5 0 0 0 4.296 8.385l-.863 7.742a1.1 1.1 0 0 0 1.09 1.218h14.717a1.1 1.1 0 0 0 1.09-1.218l-.863-7.742a10.5 10.5 0 0 0 4.297-8.384V39.85a11.883 11.883 0 0 0-11.88-11.883"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M25.956 71.644c5.757 0 10.424-.737 10.424-1.646 0-.91-4.667-1.646-10.424-1.646s-10.424.737-10.424 1.646 4.667 1.646 10.424 1.646"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m23.976 68.24.286-6.602h-5.568v6.602zM27.937 68.24l-.287-6.602h5.568v6.602z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M17.863 67.203a1.1 1.1 0 0 0 .919 1.698h4.516a1.098 1.098 0 0 0 .975-1.602c-1.2-2.314-5.042-2.185-6.41-.096M34.05 67.203a1.099 1.099 0 0 1-.919 1.698h-4.514a1.1 1.1 0 0 1-.974-1.602c1.196-2.314 5.038-2.185 6.407-.096"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M18.694 39.852v4.441a5.47 5.47 0 0 0 2.565 4.68 1.1 1.1 0 0 1 .392 1.301l-.936 2.364a1.1 1.1 0 0 1-1.57.55 9 9 0 0 1-.776-.511M33.218 39.852v4.441a5.47 5.47 0 0 1-2.564 4.68 1.1 1.1 0 0 0-.393 1.301l.937 2.364a1.1 1.1 0 0 0 1.57.55q.4-.235.776-.511"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m22.756 33.83 3.2 8.002 3.2-8.002-3.2-2.56z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  stroke: "#1E255D",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m24.145 37.305 1.811-6.036 1.811 6.037-1.81 4.526z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M28.636 28.272a.346.346 0 0 1-.267-.337l.004-2.417h-4.816l-.005 2.408a.35.35 0 0 1-.275.345l2.68 2.999z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m22.756 33.83 3.2-2.56-2.677-2.999c-.83.192-1.638.474-2.409.84zM29.157 33.83l-3.2-2.56 2.678-2.999c.832.192 1.64.473 2.41.84z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m20.675 34.57-.588 2.94a.55.55 0 0 0 .235.565l5.637 3.757-5.084-12.709q-.9.423-1.717.991l-1.484 3.703a.55.55 0 0 0 .51.753z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m31.238 34.57.588 2.94a.55.55 0 0 1-.236.565l-5.636 3.757 5.084-12.709q.9.423 1.717.991l1.48 3.703a.55.55 0 0 1-.509.753z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M25.956 61.639V41.833"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M25.965 27.147a6.58 6.58 0 0 0 6.263-4.623h.006c2.087 0 2.214-3.297.33-3.297v-1.322a6.602 6.602 0 0 0-13.204 0v1.32c-1.884 0-1.757 3.297.33 3.297h.006a6.58 6.58 0 0 0 6.269 4.625"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E255D",
  d: "M23.817 18.565a.825.825 0 1 0 0 1.65.825.825 0 0 0 0-1.65M28.109 18.565a.824.824 0 1 0 .314.063.8.8 0 0 0-.317-.063z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M22.662 21.206a.66.66 0 1 1-1.32 0 .66.66 0 0 1 1.32 0M30.584 21.206a.66.66 0 1 1-1.32 0 .66.66 0 0 1 1.32 0"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M24.315 23.247a2.98 2.98 0 0 0 3.297 0"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.325 15.246c2.894 2.809 7.887 2.345 10.893 1.328a7.262 7.262 0 0 0-14.522.01v2.293s3.63-.907 3.63-3.631"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M22.325 15.246c2.894 2.809 7.887 2.345 10.893 1.328a7.262 7.262 0 0 0-14.522.01v2.293s3.63-.907 3.63-3.631"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22.325 15.246c-.335-.324-.383-.273-.656-.689"
})));
export { SvgDoctorOffice as ReactComponent };